import React, { useContext, useEffect, memo, useState } from "react";
import { withRouter } from "react-router-dom";
// import Spinner from "../../Spinner/Spinner";

import Row from "./Row";
import Cargando from "../../../../components/Extra/Cargando";
import TablaCabecera from "../../../../components/Extra/TablaCabecera";
import AuthContext from "../../../../Context/Auth/AuthContext";
// MATERIAL
import { makeStyles } from "@mui/styles";
import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  Typography,
  TableRow,
  Box,
} from "@mui/material";
import ConfirmacionDialog from "../../../components/Dialogs/ConfirmacionDialog";
import {
  Cancel,
  DeleteForever,
  ListRounded,
  MenuBook,
  PictureAsPdf,
  Refresh,
} from "@mui/icons-material";
import ToolBarTable from "../../../components/Tablas/ToolBarTable";
import DialogOpciones from "../../../components/Dialogs/DialogOpciones";
import clienteAxios from "../../../../config/axios";
import { saveAs } from "file-saver";
import AlertaContext from "../../../../Context/Alerta/AlertaContext";
const useStyles = makeStyles({
  root: {
    width: "100%",
  },
  container: {
    maxHeight: 600,
  },
});
const tabla = "caja";
const titulo = "Caja General";
const TablaAsignaturas = (props) => {
  const {
    setagregar,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    rows,
    search,
    input,
    orden,
    setinput,
    setorden,
    cargando,
    setcargando,
    fullBuscador,
    estadoRequest,
    seteditar,
    // STATE
    addRowsState,
    getDataState,
    remplazarRowsState,
    obtenerState,
    pagination,
    columns,
    // ObjectoActivo,
    changeObjetoActivoState,
    // rowsImportState,
    // export
    arrayExport,
    setarrayExport,
    campoExport,
    socket,
  } = props;

  const {
    usuario,
    usuario: { rucempresa },
  } = useContext(AuthContext);
  //columnas y rows de la tabla
  const { mostrarAlerta } = useContext(AlertaContext);
  // eslint-disable-next-line
  const clases = useStyles();
  // eslint-disable-next-line

  // eslint-disable-next-line
  // eslint-disable-next-line
  // eslint-disable-next-line

  const reducer = (previousValue, currentValue) =>
    Number(previousValue) + Number(currentValue);

  // ABRE EL DIALOG DE OPCIONES
  const [openDialogOpciones, setopenDialogOpciones] = useState(false);
  // ABRE EL DIALOG DE CONFIRMACION PARA ELIMINAR
  const [openCDEliminar, setopenCDEliminar] = useState(false);
  // DESHABILITA BOTONES DEL DIALOG SI ESTA CARGANDO
  const [cargandoDialogOpciones, setcargandoDialogOpciones] = useState(false);
  const handleEliminar = async () => {
    await setcargando(true);

    await setTimeout(async () => {
      // socket.current.emit("client:eliminarDataSeleccionado", {
      //   rucempresa: usuario.rucempresa,
      //   rol: usuario.rol,
      //   tabla: "caja",
      //   lista: arrayExport,
      // });
      setcargandoDialogOpciones(false);
      setopenCDEliminar(false);
      setcargando(false);
    }, 500);
  };
  //clases
  const classes = useStyles();

  const handleChangePage = async (event, newPage) => {
    if (newPage * rowsPerPage + rowsPerPage > rows.length) {
      setcargando(true);
      const res = await getDataState(
        rowsPerPage,
        newPage,
        search,
        input.id,
        orden,
        JSON.stringify(fullBuscador),
        rucempresa,
        estadoRequest,
      );

      const data = res.data.data.results;
      setcargando(false);
      const resultado = data.filter((row) => {
        const existe = rows.some((item, index) => {
          return row.cajaId === item.cajaId;
        });

        return !existe;
      });

      addRowsState(resultado);
    }

    setPage(newPage);
  };

  // eslint-disable-next-line

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    if (page === 0) {
      if (event.target.value > rows.length) {
        obtenerState(
          event.target.value,
          0,
          search,
          input.id,
          orden,
          JSON.stringify(fullBuscador),
          rucempresa,
          estadoRequest,
        );
      }
    }
  };
  const funcionOrdenar = async (column) => {
    setcargando(true);
    await remplazarRowsState(
      rowsPerPage,
      0,
      search,
      column.id,
      !orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest,
    );
    setPage(0);
    setinput(column);
    setorden(!orden);
    setcargando(false);
  };
  const funcionReload = async () => {
    try {
      setcargando(true);
      setRowsPerPage(10);
      setPage(0);
      await obtenerState(
        10,
        0,
        search,
        input.id,
        orden,
        JSON.stringify(fullBuscador),
        rucempresa,
        estadoRequest,
      );
      setcargando(false);
    } catch (error) {}
  };

  useEffect(() => {
    //eslint-disable-next-line

    obtenerState(
      10,
      0,
      search,
      input.id,
      orden,
      JSON.stringify(fullBuscador),
      rucempresa,
      estadoRequest,
    );

    // eslint-disable-next-line
  }, []);

  const funcPdf = async (tipo) => {
    try {
      const json = {
        rucempresa: usuario.rucempresa,
        tipo,
        lista: arrayExport.map((itemExport) => itemExport[campoExport]),
        search,
        search_avanzado: fullBuscador,
        titulo,
        estado: estadoRequest,
      };

      console.log(tabla);

      const res = await clienteAxios.post(
        `reportes/${tabla}`,
        {
          ...json,
        },
        { responseType: "blob" },
      );
      const pdfBlob = new Blob([res.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${titulo}.pdf`);
      setopenDialogOpciones(false);
    } catch (error) {
      console.log({ error });

      mostrarAlerta("Hubo un error", "error");
      setcargandoDialogOpciones(false);
    }
  };
  const funcExcel = async (tipo) => {
    try {
      const json = {
        rucempresa: usuario.rucempresa,
        tipo,
        lista: arrayExport.map((itemExport) => itemExport[campoExport]),
        search,
        search_avanzado: fullBuscador,
        titulo,
        estado: estadoRequest,
      };

      const res = await clienteAxios.post(
        `reportes/excel/${tabla}`,
        {
          ...json,
        },
        { responseType: "blob" },
      );

      const pdfBlob = new Blob([res.data], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(pdfBlob, `${titulo}.xlsx`);
      setopenDialogOpciones(false);
    } catch (error) {
      mostrarAlerta("Hubo un error", "error");
      setcargandoDialogOpciones(false);
    }
  };

  //si no hay usuarios //rows no cargar el componente
  if (!rows) {
    return <Cargando titulo="Cargando" />;
  }
  if (!pagination) {
    return <Cargando titulo="Cargando" />;
  }

  return (
    <Paper className={classes.root}>
      <ConfirmacionDialog
        open={openCDEliminar}
        setopen={setopenCDEliminar}
        categoria="warning"
        titulo={`¿Esta seguro de eliminar estos registros?`}
        botones={[
          {
            tooltip: "Se eliminaran los registros",
            texto: "SI",
            funcion: async () => {
              await handleEliminar();
            },
            disabled: false,
            Icon: DeleteForever,
            color: "error",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: { marginRight: ".3rem" },
          },
          {
            tooltip: "Cancelar",
            texto: "NO",
            funcion: () => {
              setopenCDEliminar(false);
            },
            disabled: false,
            Icon: Cancel,
            color: "secondary",
            id: 2,
            ocultar: false,
            tipo: "boton",
            variante: "contained",
            size: "medium",
            sx: {},
          },
        ]}
      />
      <DialogOpciones
        open={openDialogOpciones}
        setopen={setopenDialogOpciones}
        botones={[
          {
            tooltip: "Exportar",
            funcion: async () => {
              funcExcel("seleccion");
            },
            Icon: MenuBook,
            color: "success",
            id: 1,
            disabled: cargandoDialogOpciones,
          },
          // {
          //   tooltip: "Exportar (Todos)",
          //   funcion: async () => {
          //     funcExcel("todos");
          //   },
          //   Icon: MenuBook,
          //   color: "success",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          {
            tooltip: "Exportar",
            funcion: async () => {
              funcPdf("seleccion");
            },
            Icon: PictureAsPdf,
            color: "error",
            id: 1,
            disabled: cargandoDialogOpciones,
          },
          // {
          //   tooltip: "Exportar (Todos)",
          //   funcion: async () => {
          //     funcPdf("todos");
          //   },
          //   Icon: PictureAsPdf,
          //   color: "error",
          //   id: 1,
          //   disabled: cargandoDialogOpciones,
          // },
          {
            tooltip: "Eliminar",
            funcion: () => {
              setopenCDEliminar(true);
            },
            Icon: DeleteForever,
            color: "error",
            id: 2,
            disabled: cargandoDialogOpciones,
          },
        ]}
        titulo={"Acciones"}
      />
      <ToolBarTable
        pagination={pagination}
        rowsPerPage={rowsPerPage}
        rows={rows}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        ocultarPaginacion={false}
        botonesIzquierdos={[
          {
            tooltip: "Actualizar",
            texto: "Actualizar",
            funcion: () => {
              funcionReload(true);
            },
            disabled: false,
            Icon: Refresh,
            color: "primary",
            id: 1,
            ocultar: false,
            tipo: "boton",
            variante: "text",
            size: "medium",
            sx: {},
          },
        ]}
        botonesDerechos={[
          {
            tooltip: "Exportar",
            texto: "",
            funcion: () => {
              setopenDialogOpciones(true);
            },
            disabled: arrayExport.length === 0,
            Icon: ListRounded,
            color: "primary",
            id: 1,
            ocultar: false,
            tipo: "icono",
            variante: "text",
            size: "medium",
            sx: { margin: 0, padding: 0 },
          },
        ]}
      />
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table" id="tabla" size="small">
          {/* <ModalCarnet setopen={setopen} onChangeCarnetActivo={onChangeCarnetActivo}/> */}
          {estadoRequest === "DIARIA" ? null : (
            <caption
              style={{
                padding: "0px",
                paddingRight: "1rem",
                paddingLeft: "1rem",
              }}
            ></caption>
          )}

          <TableHead>
            <TablaCabecera
              remplazarRowsState={remplazarRowsState}
              search={search}
              input={input}
              setinput={setinput}
              orden={orden}
              setorden={setorden}
              rowsPerPage={rowsPerPage}
              page={page}
              setPage={setPage}
              setcargando={setcargando}
              rows={rows}
              setarrayExport={setarrayExport}
              columns={columns}
              habilitarOrdenar={true}
              funcionOrdenar={funcionOrdenar}
            />
          </TableHead>
          <TableBody>
            {cargando ? (
              <TableCell
                size="small"
                align="center"
                colSpan={columns.length + 2}
              >
                <Cargando titulo="Cargando" />
              </TableCell>
            ) : (
              rows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <Row
                      arrayExport={arrayExport}
                      setarrayExport={setarrayExport}
                      row={row}
                      index={index}
                      campoExport={campoExport}
                      key={row.cajaId}
                      seteditar={seteditar}
                      setagregar={setagregar}
                      changeObjetoActivoState={changeObjetoActivoState}
                      socket={socket}
                    />
                  );
                })
            )}
          </TableBody>
          <TableRow>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <>
              <TableCell
                size="small"
                align="center"
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <Typography
                  variant="body2"
                  color="secondary"
                  style={{
                    fontWeight: "bold",
                    padding: ".0",
                    margin: 0,
                    borderBottom: "1px solid",
                  }}
                  component={"span"}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          const existe = arrayExport.some(
                            (itemE) => itemE[campoExport] === row[campoExport],
                          );

                          if (existe) {
                            return row.cajaEstado === "ANULADA"
                              ? 0
                              : Number(row.cajaIngreso);
                          }
                          return 0;
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>
                <Typography
                  variant="body2"
                  color="primary"
                  style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                  component={"span"}
                >
                  $
                  {rows.length === 0
                    ? null
                    : rows
                        .map((row) => {
                          return row.cajaEstado === "ANULADA"
                            ? 0
                            : Number(row.cajaIngreso);
                        })
                        .reduce(reducer)
                        .toFixed(2)}
                </Typography>
              </TableCell>
              <TableCell size="small" align="center">
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="body2"
                    color="secondary"
                    style={{
                      fontWeight: "bold",
                      padding: ".0",
                      margin: 0,
                      borderBottom: "1px solid",
                    }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            const existe = arrayExport.some(
                              (itemE) =>
                                itemE[campoExport] === row[campoExport],
                            );

                            if (existe) {
                              return row.cajaEstado === "ANULADA"
                                ? 0
                                : Number(row.cajaEgreso);
                            }
                            return 0;
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            return row.cajaEstado === "ANULADA"
                              ? 0
                              : Number(row.cajaEgreso);
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell size="small" align="center">
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="body2"
                    color="secondary"
                    style={{
                      fontWeight: "bold",
                      padding: ".0",
                      margin: 0,
                      borderBottom: "1px solid",
                    }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            const existe = arrayExport.some(
                              (itemE) =>
                                itemE[campoExport] === row[campoExport],
                            );

                            if (existe) {
                              return row.cajaEstado === "ANULADA"
                                ? 0
                                : Number(row.cajaCredito);
                            }
                            return 0;
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            return row.cajaEstado === "ANULADA"
                              ? 0
                              : Number(row.cajaCredito);
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                </Box>
              </TableCell>
              <TableCell size="small" align="center">
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <Typography
                    variant="body2"
                    color="secondary"
                    style={{
                      fontWeight: "bold",
                      padding: ".0",
                      margin: 0,
                      borderBottom: "1px solid",
                    }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            const existe = arrayExport.some(
                              (itemE) =>
                                itemE[campoExport] === row[campoExport],
                            );

                            if (existe) {
                              return row.cajaEstado === "ANULADA"
                                ? 0
                                : Number(row.cajaMonto);
                            }
                            return 0;
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="primary"
                    style={{ fontWeight: "bold", padding: ".0", margin: 0 }}
                    component={"span"}
                  >
                    $
                    {rows.length === 0
                      ? null
                      : rows
                          .map((row) => {
                            return row.cajaEstado === "ANULADA"
                              ? 0
                              : Number(row.cajaMonto);
                          })
                          .reduce(reducer)
                          .toFixed(2)}
                  </Typography>
                </Box>
              </TableCell>
            </>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
            <TableCell size="small" align="center"></TableCell>
          </TableRow>
        </Table>
      </TableContainer>
    </Paper>
  );
};
export default memo(withRouter(TablaAsignaturas));
